import React from 'react'

import { useSelector } from 'react-redux'
import { faFlaskGear } from '@fortawesome/pro-solid-svg-icons'

import { ColorsPalette } from '../../config/colors'
import TooltipIcon from '../icons/TooltipIcon'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const ExperimentalTitle = ({ title }) => {
  const t = useSelector(selectTranslate)
  return (
    <div className='experimental-title'>
      <TooltipIcon title={t('experimental_icon.title')} icon={faFlaskGear} color={ColorsPalette.BLUE_ICON} />
      &nbsp;
      {t(title)}
    </div>
  )
}

export default ExperimentalTitle
